import { MESSAGES } from "@app/constant";
import { throwImageFiltering } from "@app/helpers/uploadFileValidation";

import { handleDeleteImageProps, onChangeMultipleUploadProps, onChangeSingleUploadProps } from "./types";
import { recipeFirstKey } from "./constant";

export const onChangeMultipleUpload = ({
  index,
  event,
  watch,
  setValue,
  setState,
  setError,
  clearErrors,
}: onChangeMultipleUploadProps) => {
  setState((prev) => ({ ...prev, largeImageMessage: '' }))

  const uploadedFiles = watch(`${recipeFirstKey}.${index}.uploadedFiles`)
  const existingImages = watch(`${recipeFirstKey}.${index}.existingImages`)

  try {
    const fileList = event.target?.files as FileList;

    const onChangeFiles = throwImageFiltering(fileList)

    const chosenImagesLength = Object.keys(onChangeFiles || {}).length

    if (!onChangeFiles) {
      setError(`${recipeFirstKey}.${index}.uploadedFiles`, { message: MESSAGES.imageIsRequired })
    }

    if ((existingImages.length + chosenImagesLength) > 5) {
      setError(`${recipeFirstKey}.${index}.uploadedFiles`, { message: MESSAGES.notMoreFiveImage })

      return
    }

    if (fileList.length !== onChangeFiles.length) {
      setState((prev) => ({ ...prev, largeImageMessage: MESSAGES.imageSize }))
    }

    const newDataTransfer = new DataTransfer();

    let array = [...Array.from(fileList)]

    if (uploadedFiles instanceof FileList) {
      array = [
        ...array,
        ...Array.from(uploadedFiles)
      ]
    }

    array.forEach((file) => {
      newDataTransfer.items.add(file)
    });

    clearErrors(`${recipeFirstKey}.${index}.uploadedFiles`)
    setValue(`${recipeFirstKey}.${index}.uploadedFiles`, newDataTransfer.files)
  } catch (error) {
    console.log('Error:', error);
  }
}

export const onChangeSingleUpload = ({
  event,
  watch,
  setValue,
  setState,
  setError,
  clearErrors,
}: onChangeSingleUploadProps) => {
  setState((prev) => ({ ...prev, largeImageMessage: '' }))

  const images = watch('uploadedFiles')

  // I had to add this condition for image different type
  // which one is FileList and second is Image (interface)
  const calcedCount = images instanceof FileList ? images?.length || 0 : images ? 1 : 0

  try {
    const fileList = event.target?.files as FileList;

    const onChangeFiles = throwImageFiltering(fileList)

    const chosenImagesLength = Object.keys(onChangeFiles || {}).length

    if (!onChangeFiles) {
      setError('uploadedFiles', { message: MESSAGES.imageIsRequired })
    }

    if (((calcedCount) + chosenImagesLength) > 5) {
      setError('uploadedFiles', { message: MESSAGES.notMoreFiveImage })

      return
    }

    if (fileList.length !== onChangeFiles.length) {
      // if lengths does not equal that means, user uploaded strnger file
      setState((prev) => ({ ...prev, largeImageMessage: MESSAGES.imageSize }))

      return
    }

    setValue('existingImages', [])
    setValue('uploadedFiles', fileList)
    clearErrors('uploadedFiles')
  } catch (error) {
    console.log('Error:', error);
  }
}

export const handleDeleteImage = ({
  bas64,
  instId,
  previews,
  watch,
  setValue,
  setState,
}: handleDeleteImageProps) => {
  //  @ts-ignore
  const selectedPreviews = previews[instId] as string[]

  const instructions = watch(recipeFirstKey)

  if (!instructions?.length) {
    return
  }

  const found = instructions?.find(({ id }) => id === instId)

  if (!found) {
    return
  }

  const { uploadedFiles, existingImages } = found

  const key = `${recipeFirstKey}[${instId}].` as const

  const isFileList = uploadedFiles instanceof FileList

  const index = selectedPreviews.findIndex((item) => item === bas64);

  if (existingImages?.length) {
    const [_, name] = bas64.split('images/')

    const files = existingImages.filter((item) => item.url !== `images/${name}`)

    const updated = instructions.map((inst) => {
      if (inst.id === instId) {
        return { ...inst, existingImages: [...files] }
      }

      return { ...inst }
    })

    setValue(recipeFirstKey, updated)
    setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
  }

  if (isFileList) {
    const files = Array.from(uploadedFiles).filter((_, i) => i !== index);

    const mergedFileList = new DataTransfer();

    files.forEach((file: any) => {
      mergedFileList.items.add(file);
    });

    const updated = instructions.map((inst) => {
      if (inst.id === instId) {
        return { ...inst, uploadedFiles: mergedFileList.files }
      }

      return { ...inst }
    })

    setValue(recipeFirstKey, updated)
    setState((prev) => ({ ...prev, isDeleteModalOpen: false }))
  }
}
